import request from '@/utils/request'

export function createMerchant(data) {
  return request({
    url: '/web/merchant/create',
    method: 'post',
    data
  })
}
export function merchantList(data) {
  return request({
    url: '/web/merchant/list',
    method: 'post',
    data
  })
}

// 平台商户充值
export function platformMerchantRecharge(data) {
  return request({
    url: '/web/platform/merchant/recharge',
    method: 'post',
    data
  })
}

// 平台商户充值列表（config 可传 timeout 等 axios 配置，导出大批量数据时使用）
export function platformMerchantRechargeList(data, config = {}) {
  return request({
    url: '/web/platform/merchant/recharge/list',
    method: 'post',
    data,
    ...config,
  })
}
export function merchantDetail(data) {
  return request({
    url: '/web/merchant/detail',
    method: 'post',
    data
  })
}
export function changeMerchant(data) {
  return request({
    url: '/web/merchant/update',
    method: 'post',
    data
  })
}

// 门店列表（config 可传 timeout 等 axios 配置）
export function storesList(data, config = {}) {
  return request({
    url: '/web/store/list',
    method: 'post',
    data,
    ...config,
  })
}

// 创建门店（config 可传 silent 等，批量导入时避免逐条弹窗）
export function createStores(data, config = {}) {
  return request({
    url: '/web/store/create',
    method: 'post',
    data,
    ...config,
  })
}

// 修改门店
export function changeStores(data) {
  return request({
    url: '/web/store/update',
    method: 'post',
    data
  })
}

// 批量门店信息
export function batchStoreInformation(data) {
  return request({
    url: '/web/store/details',
    method: 'post',
    data
  })
}

// 批量删除门店
export function deleteStores(data) {
  return request({
    url: '/web/store/delete',
    method: 'post',
    data
  })
}

// 门店秘钥重置
export function resetStoresSecret(data) {
  return request({
    url: '/web/store/secret/reset',
    method: 'post',
    data
  })
}

// 图片上传
export function uploadImg(data) {
  return request({
    url: '/web/fs/upload',
    method: 'post',
    data
  })
}